//
// Copyright (C) 2025 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/SupportedValuesChange.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PropIdAreaId } from "./PropIdAreaId_pb";
import { file_android_hardware_automotive_vehicle_PropIdAreaId } from "./PropIdAreaId_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/SupportedValuesChange.proto.
 */
export const file_android_hardware_automotive_vehicle_SupportedValuesChange: GenFile = /*@__PURE__*/
  fileDesc("Cj9hbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9TdXBwb3J0ZWRWYWx1ZXNDaGFuZ2UucHJvdG8SKWFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvImoKFVN1cHBvcnRlZFZhbHVlc0NoYW5nZRJRChBwcm9wX2lkX2FyZWFfaWRzGAEgAygLMjcuYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8uUHJvcElkQXJlYUlkYgZwcm90bzM", [file_android_hardware_automotive_vehicle_PropIdAreaId]);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.SupportedValuesChange
 */
export type SupportedValuesChange = Message<"android.hardware.automotive.vehicle.proto.SupportedValuesChange"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.PropIdAreaId prop_id_area_ids = 1;
   */
  propIdAreaIds: PropIdAreaId[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.SupportedValuesChange.
 * Use `create(SupportedValuesChangeSchema)` to create a new message.
 */
export const SupportedValuesChangeSchema: GenMessage<SupportedValuesChange> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_SupportedValuesChange, 0);

